import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "../../_hooks/useForm";
import HttpClient from "../../_services/httpClient";
import {BackgroundPartnerInfo} from "./style";
import {savePartnerID} from "../../_store/_actions/repositoryDataActions";

const PartnerInfo = ({SearchBar}) => {
    const dispatch = useDispatch();
    const [partnerInfo, setPartnerInfo] = useState({});
    const userInfo = useSelector(state => state.repository.user);
    const partnerData = useSelector(state => state.repository.partner);
    const [formValues, handleInputChange] = useForm({
        partnerId: '',
    });

    const { partnerId } = formValues;

    const getData = (url) => {
        return new Promise((resolve, eject) => {
            HttpClient.get(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    eject(error);
                })
        });
    }

    const handleFindPartner = (id, updateStore) => {
        getData(`/partner/ById/${id}`).then((response) => {
            if (response.status === 200) {
                setPartnerInfo(response.data);
                if (updateStore) {
                    dispatch(savePartnerID(parseInt(partnerId)));
                }
            }
        })
    }

    useEffect(() => {
        if (partnerData == null || partnerData.email1 == null) {
            if (userInfo.partnerId) {
                handleFindPartner(userInfo.partnerId, false);
            }
        } else {
            setPartnerInfo(partnerData);
        }
    }, []);

    return (
        <>
            <BackgroundPartnerInfo>

                <div className="card-body">
                    <div className="row nomargin nopadding">
                        <div className="col_full nomargin nopadding">

                            <div className="row">
                                <div className="col_full">
                                    <label htmlFor="dashboard-form-email">Shared Economy Partner:</label>
                                    { SearchBar &&
                                        <div className="input-group mb-3">
                                            <input type="text"
                                                id="partnerId"
                                                name="partnerId"
                                                className="form-control not-dark"
                                                value={ partnerId }
                                                onChange={handleInputChange}
                                            />
                                            <div className="input-group-append">
                                                <button className="button button-3d button-black nomargin" type="button"
                                                    id="button-addon2"
                                                    onClick={handleFindPartner(partnerId, true)}
                                                    >Find partner
                                                </button>
                                            </div>
                                        </div>
                                    }

                                    <div className="partner-info">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>Name:<span>{partnerInfo.fullName}</span></label>
                                            </div>
                                            <div className="col-md-6">
                                                <label>Email:<span>{partnerInfo.email1}</span></label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>Address:<span>{partnerInfo.address}</span></label>
                                            </div>
                                            <div className="col-md-6">
                                                <label>Resort Contract:<span>{partnerInfo.contractFolio}</span></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </BackgroundPartnerInfo>
        </>
    );
};

export default PartnerInfo;
